import { DocumentNoteHeader } from "../../../AdminLayout_Style";
import { EBlogResponse, IBlogGetPage } from "../../../models/blog";
import {
  ActionButton,
  BlogListWrapper,
  BlogTable,
  BlogTd,
  BlogTh,
  StatusBadge,
} from "../../../style/admin/Blog_Style";
import { toast } from "../../../utils/notify";
import { useEffect, useState } from "react";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import { useNavigate } from "react-router-dom";
import { EPageResponse, IPageGetPage } from "../../../models/page";
import PageService from "../../../services/api/page.service";

// const blogs = [
//   {
//     id: 1,
//     title: "Giới thiệu ReactJS",
//     author: "Admin",
//     createdAt: "20/01/2026",
//     status: "active",
//   },
//   {
//     id: 2,
//     title: "Hướng dẫn Styled Components",
//     author: "Admin",
//     createdAt: "18/01/2026",
//     status: "inactive",
//   },
// ];

const PageList = () => {
  //const [openModal, setOpenModal] = useState(false);
  const [pages, setPages] = useState<EPageResponse[]>();
  const [page, setPage] = useState<EPageResponse | null>(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const navigate = useNavigate();

  const getPage = async () => {
    const data: IPageGetPage = {
      CurrentPage: 1,
      PageSize: 10,
      KeySearch: "",
    };

    var res = await PageService.getPage(data);

    if (res.success) {
      setPages(res.items);
    }
  };

  useEffect(() => {
    getPage();
  }, []);

  // const handleOpenModal = (data?: EBlogResponse) => {
  //   data && setBlog(data);
  //   setOpenModal(true);
  // };

  // const handleCloseModal = () => {
  //   setBlog(null);
  //   setOpenModal(false);
  // };

  const handleComfrimDeleteModal = () => {
    getPage();
    setOpenDeleteModal(false);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  // const handleSumit = () => {
  //   getPage();
  //   setOpenModal(false);
  // };

  return (
    <>
      <DocumentNoteHeader>
        <h3>Danh sách Page</h3>
        {/* <button onClick={() => navigate("/admin/blog/detail")}>
          + Thêm Blog
        </button> */}
      </DocumentNoteHeader>

      <BlogListWrapper>
        <BlogTable>
          <thead>
            <tr>
              <BlogTh>#</BlogTh>
              <BlogTh>Tên</BlogTh>
              <BlogTh>Url</BlogTh>
              <BlogTh>Thao tác</BlogTh>
            </tr>
          </thead>
          <tbody>
            {pages &&
              pages.map((page, index) => (
                <tr key={page.id}>
                  <BlogTd>{index + 1}</BlogTd>
                  <BlogTd>{page.name}</BlogTd>
                  <BlogTd>{page.url}</BlogTd>
                  <BlogTd>
                    <ActionButton
                      onClick={() => navigate(`/admin/page/detail/${page.id}`)}>
                      Sửa
                    </ActionButton>
                    {/* <ActionButton
                      className="delete"
                      onClick={() => {
                        page.id && setDeleteId(page.id);
                        setOpenDeleteModal(true);
                      }}>
                      Xóa
                    </ActionButton> */}
                  </BlogTd>
                </tr>
              ))}
          </tbody>
        </BlogTable>
      </BlogListWrapper>

      <ConfirmDeleteModal
        open={openDeleteModal}
        blogId={deleteId}
        onClose={handleCloseDeleteModal}
        onConfirm={handleComfrimDeleteModal}
      />

      {/* <BlogCreateModal
        blog={blog}
        open={openModal}
        onClose={handleCloseModal}
        onHandleSubmit={handleSumit}
      /> */}
    </>
  );
};

export default PageList;
